import { api } from './utils'
import { IUploadServerAnswer } from './customization'
import { StatusCodes } from 'http-status-codes'

export async function signUpVerify(link: string): Promise<IVerifyAnswer> {
	const query = await fetch(`${api}/verify/signUp`, {
		method: 'POST',
		body: JSON.stringify({ link })
	})
	const result = await query.json() as IVerifyAnswer
	return result ? { code: 200 } : { code: 403 }
}

export async function restoreVerify(link: string, password: string): Promise<IUploadServerAnswer> {
	const query = await fetch(`${api}/verify/restore`, {
		method: 'POST',
		body: JSON.stringify({ link, password })
	})
	return await query.json() as IUploadServerAnswer
}

export interface IVerifyAnswer {
	code: StatusCodes.INTERNAL_SERVER_ERROR | StatusCodes.OK | StatusCodes.FORBIDDEN
}
